import EnsureRole from 'lib/access/EnsureRole';
import { useGetOrganizationTicketCounterQuery } from 'lib/graphql/graphql';
import useOrganization from 'providers/organization/useOrganization';
import { PropsWithChildren } from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'wouter';

import { Banner, BannerContainer } from './styles';

function b(chunks: React.ReactNode) {
  return (
    <b>{chunks}</b>
  );
}

function link(chunks: React.ReactNode) {
  return (
    <Link href="/payouts">{chunks}</Link>
  );
}

function OrganizationCounterBanner(props: PropsWithChildren) {
  const { children } = props;

  const { organizationId } = useOrganization();

  const { data, loading } = useGetOrganizationTicketCounterQuery({
    variables: { id: organizationId! },
    fetchPolicy: 'network-only',
    skip: !organizationId,
  });
  const counter = data?.getOrganizationTicketCounter;
  const count = counter?.count || 0;
  const max = counter?.max || -1;

  const showBanner = !loading && max > 0;
  const value = count / max;
  const almostAtLimit = value > 0.9;

  return (
    <BannerContainer>
      {showBanner && (
        <Banner $almostAtLimit={almostAtLimit}>
          <FormattedMessage
            id={`organization_stripe_not_configured_${almostAtLimit ? 'error' : 'warning'}`}
            values={{ b, remaining: max - count }}
          />
          <br />
          <EnsureRole
            requiredRole="ADMIN"
            fallback={(
              <FormattedMessage
                id="organization_stripe_not_configured_staff_instructions"
              />
            )}
          >
            <FormattedMessage
              id="organization_stripe_not_configured_admin_instructions"
              values={{ link }}
            />
          </EnsureRole>
        </Banner>
      )}
      {children}
    </BannerContainer>
  );
}

export default OrganizationCounterBanner;
